/* The house pieces the Define toolbar and placement block are built from, held once so no copy drifts. */

/* The ring every control in these panels shows when the keyboard reaches it, in one place
   because a ring that differs between two buttons reads as one of them being broken. */
export const FOCUS_RING =
  "focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/30";

export { CHOICE_CONTROL as PANEL_CONTROL } from "@/components/ui/ChoiceGroup";

/* Shape only, no fill: each placement button states its own, which a fill here would race. */
export const ADD_BUTTON =
  "flex h-8 items-center gap-1.5 whitespace-nowrap rounded-[8px] border px-3 text-[12px] font-semibold";

/* The toolbar. The track carries the fill and the segments sit transparent over it, so
   SEGMENTED_OFF greys a group at once and is the only dimmer: opacity multiplies. */
export const TOOLBAR_STRIP =
  "mb-2.5 flex flex-wrap items-end gap-2.5 rounded-tip border border-border bg-background px-2.5 py-[9px]";

export const TOOLBAR_GROUP = "flex flex-col items-center gap-[5px]";

export const SEGMENTED =
  "inline-flex overflow-hidden rounded-sm border border-border bg-card";

export const SEGMENTED_OFF = "bg-muted opacity-55";

/* What every cell of a track looks like, whichever kind of track it is. Held apart from the
   two so a restyle of the row cannot land on one idiom and miss the other. */
const TRACK_CELL = `grid h-[26px] cursor-pointer place-items-center text-muted-foreground enabled:hover:bg-background enabled:hover:text-foreground disabled:cursor-not-allowed ${FOCUS_RING}`;

export const SEGMENT = `${TRACK_CELL} w-10 border-l border-border first:border-l-0`;

export const SEGMENT_CHOSEN =
  "bg-muted text-primary shadow-[inset_0_0_0_1px_var(--color-border)]";

/* The stepper: a value with a step either side of it, on the segmented control's own track
   so a strip carrying both reads as one row of controls rather than two idioms. */
export const STEPPER = `${SEGMENTED} items-center`;

export const STEP_BUTTON = `${TRACK_CELL} w-[26px] disabled:text-muted-foreground/45`;

/* Mono and wide enough for the longest reading it takes, so the buttons either side of it
   do not move as the value changes. */
export const STEP_VALUE =
  "min-w-[46px] border-x border-border text-center font-mono text-[12px] font-semibold leading-[26px]";

/* The rule between two runs of groups that do different jobs. */
export const TOOLBAR_DIVIDER = "w-px self-stretch bg-border";
